import { NotificationSlugEnum } from '@app/generated/graphql';
import { INotificationConfig } from '../interfaces/interface';
import { DEFAULT_MESSAGE_LIFE } from './notification.constants';

export const EXAMPLE_NOTIFICATION_CONFIG: INotificationConfig = {
  slug: NotificationSlugEnum.Example,
  preference: {
    displayTitle: 'Example',
    displayDescription: 'Example',
    defaultConfig: {},
  },
  message: {
    iconPath: '/assets/icons/general/info.svg',
    displayTitle: 'Example',
    displayDescription: 'Example',
    actionLabel: 'View',
    action: (_metadata: Record<string, unknown>) => {},
    life: DEFAULT_MESSAGE_LIFE,
  },
};
